import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import type {ButtonGroupSkeletonProps} from './button-group-skeleton.types';
import {ButtonGroupSkeleton} from './button-group-skeleton';

export const buttonGroupSkeletonRegistration = defineStreamComponentRegistration(
  StreamComponentType.BUTTON_GROUP_SKELETON,
  ButtonGroupSkeleton,
  (): ButtonGroupSkeletonProps => ({})
);
